import { getTestImpactScorelementId } from '@upright/test-ids/dom-elements';
import styled from 'styled-components';
import { bouTextFont } from '../../../../../../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../../../../../../generic/global/bou-colors';
import { scoreBackroundColor } from '../../../../../../../../generic/utilities/format';
import {
  useImpactChartContext,
  useImpactChartFontSizes,
  useImpactChartHeights,
  useImpactChartWidths,
} from '../../../context';
import { plusIfPositive } from '../../../shared';
import { formatImpactScore } from '../../../value-formatter';
import { DimensionRowProps } from '../types';

const DimensionScoreText = styled.text`
  ${bouTextFont};
  fill: ${BouColor.BLACK};
  font-weight: bold;
  text-anchor: middle;
`;

export function SingleSeriesMiddlePart(props: DimensionRowProps) {
  const { scoreType, formatters, scoreReaders } = useImpactChartContext();
  const { dimensionTitles: fontSize } = useImpactChartFontSizes();
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const scoreReader = scoreReaders[0];
  const total = scoreReader.readScore(undefined, props.dimension, undefined, undefined);

  const boxWidth = 70;
  const boxHeight = 32;
  const x = widths.title + widths.bars + widths.middle / 2;
  const y = heights.dimensionRowMargin + heights.dimensionRowBarHeight / 2;
  if (total === undefined) {
    return <g />;
  }
  return (
    <Root transform={`translate(${x}, ${y})`}>
      <rect
        width={boxWidth}
        height={boxHeight}
        y={-boxHeight / 2}
        x={-boxWidth / 2}
        opacity={0}
        fill={scoreBackroundColor(total)}
      />
      <DimensionScoreText id={getTestImpactScorelementId(props.dimension)} dy="0.35em" style={{ fontSize }}>
        {plusIfPositive(total)}
        {formatImpactScore(total, formatters, scoreType)}
      </DimensionScoreText>
    </Root>
  );
}

const Root = styled.g`
  transition: transform 0.12s ease-in-out;
`;
